import posthog from 'posthog-js';

export const posthogPhoneNumberEvent = (captureEvent, data) => {

  const eventData = {
    timestamp: new Date().toISOString(),
    phoneNumber : data?.phoneNumber,
    userId: data?.userId,
    orderId: data?.orderId
  };

  try {
    posthog.capture(captureEvent, eventData);
  } catch (error) {
    console.error('PostHog capture failed:', error);
  }
};
